class Timeline {
    startYear = 0;
    endYear = 0;
    order = "";
    data = {};
    constructor(startYear, endYear, order, projectTypes) {
        this.startYear = startYear;
        this.endYear = endYear;
        this.order = order;
        this.Create(projectTypes);
    };
    Years = function() {
        let years = [];
        for (let y = this.endYear; y >= this.startYear; y--) {
            years.push({ year: y });
        }
        if (this.order === "ascending") {
            years = years.reverse();
        }
        return years;
    };
    Create = function(projectTypes) {

        // Get priority types
        const years = this.Years();
        for (const year of years) {
            for (const projectType of projectTypes) {
                const { DateRange, PriorityType, ID, Name } = projectType;
                if (year.year >= DateRange.Start && year.year <= DateRange.End) {
                    year.priorityType = {
                        name: PriorityType,
                        id: ID
                    };
                    year.name = Name;
                }
                projectType.TotalYears = (DateRange.End - DateRange.Start) + 1;
            }
        }

        this.data.years = years;
        this.data.totalYears = years.length;
    };
};

Timeline.Project = class {
    years = [];
    constructor(timelineHeight, dayHeight, coordinates, years, projectIndex) {
        return this.Mapping(timelineHeight, dayHeight, coordinates, years, projectIndex);
    };

    // Draws a box spanning the timeframe of project across years (x-axis) and months (y-axis)
    Mapping = function(timelineHeight, dayHeight, coordinates, years, projectIndex) {
        const monthHeight = timelineHeight / 12;
        const {
            YearIndex,
            MonthIndex,
            X2,
            Y1,
            Y2,
            TotalYears,
            DaysIntoYear
        } = coordinates;

        // Prepare coordinates
        let x, y, width, height, totalYears;
        totalYears = years.length;
        x = (100 / totalYears) * YearIndex;
        y = (monthHeight * MonthIndex) + (Y1 * dayHeight)
        width = (100 / totalYears) * X2;
        height = Y2 - Y1;
        if (height === 0) {
            height = 1;
        }
        height = height * dayHeight;

        let totalDays = height;
        const startYear = years[YearIndex];
        const mapping = [
            {
                x,
                y,
                width,
                height,
                totalDays,
                startYear,
                projectIndex,
                yearIndex: YearIndex
            }
        ];

        // Add additional mapping for projects that extend past 1 year
        if (TotalYears > 0) {
            const height = DaysIntoYear * dayHeight;
            totalDays += height;
            mapping.push({
                x: (100 / totalYears) * (YearIndex - 1),
                y: dayHeight,
                width: (100 / totalYears) * X2,
                height,
                totalDays,
                startYear
            });
        }

        return mapping;
    };
};

module.exports = { TimelineInstance: Timeline };